/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MissingOrthoCoverage/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function MissingOrthoCoverage({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Insurances/MissingOrthoCoverage"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let paymentPlanInsurancesValueData = fromData.useDataValue({ viewPath,
context: 'payment_plan',
path: 'insurances',
})
let insuranceSubscriptionsValueData = fromData.useDataValue({ viewPath,
context: 'insurance_subscriptions',
})
let aggregateData = fromHelpers.getView(paymentPlanInsurancesValueData, insuranceSubscriptionsValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}